import React from "react";

const Sugar = () => {
    return <div className="sugar">
      <h2 className="sugar__text londrina">TOUT LE GOÛT, SANS LE SUCRE!*</h2>
    </div>;
};

export default Sugar;
